import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import {ExternalNavigationService} from './external-navigation-service.js';

import SCHEMA from './external-navigation-service.schema.yaml';

import './external-intent-handler.js';

class ExternalNavigationFeature extends AbstractFeature {
    get name() {
        return 'External Navigation';
    }

    get configSchema() {
        return SCHEMA;
    }

    updateMojitoConfig(mojitoConfig) {
        const externalNavigationService = ensureHierarchy(mojitoConfig, 'services.externalNavigationService');
        externalNavigationService.service = new ExternalNavigationService(this.config);

        super.updateMojitoConfig(mojitoConfig);
    }
}

new ExternalNavigationFeature(allFeatures);
